/* eslint-disable no-throw-literal */
import { anowVendorApiRequest } from '../../../../shared/libs/anowApiRequest';

const coverageAreaValidation = async (values, dispatch, { match, requireCoverage }) => {
  if (!requireCoverage) return;
  if (!values.latitude || !values.longitude) {
    throw {
      location: 'Latitude/longitude are required but not found for this address.',
    };
  }
  const isReady = await anowVendorApiRequest({
    url: `/company/${match.params.companyName}/coverage?lat=${
      values.latitude
    }&lon=${values.longitude}`,
  })
    .then(({ data }) => data)
    .catch((e) => {
      throw {
        location: e.response.data.Message,
      };
    });
  if (!isReady) {
    throw {
      location: 'This address appears to be outside our coverage area.',
    };
  }
};

export default coverageAreaValidation;
